export const resolveStock = (page = undefined, perpage = undefined) => {
    return ['availabilityModelService', availabilityModelService => {
        return availabilityModelService.findStock({
            page: page,
            per_page: perpage,
        }).then(list => list);
    }];
};

export const resolveSingleStock = (param = 'stock') => {
    return ['$stateParams', 'availabilityModelService', ($stateParams, availabilityModelService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? availabilityModelService.findSingleStock($stateParams[param]) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/resolvers/stock.resolver.js